
import SelectEmployee from "helpers/SelectEmployee";
import React, { useState, useEffect } from "react";
import Modal from "components/Modal/Modal";
import { Button, CardActions, CircularProgress } from "@mui/material";
import JoditEditorExample from "helpers/JoditEditorExample";
import { Add } from "@mui/icons-material";
import axios from "axios";

const AddModal = ({
    resources,
    GetEmployees,
    loggedUser,
    info,
    setInfo,
    type,
    settings,
    setSelect,
    select,
    needDirectSubmit,
    systemSettings,
    // setListOfAction={setListOfAction},
    // listOfAction={listOfAction}
}) => {
    const mainBackground = systemSettings?.mainBackground;

    const [selectEmployee, setSelectEmployee] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [loading, setLoading] = useState(false); 
    const [options, setOptions] = useState([]);
    const [listOfAction, setListOfAction] = useState([]);


    const allTheMeetings = async () => {
        const data = await axios.get('api/meeting/?status=completed');
        // setOptions(data.data.meeting);
        const meetings = data.data.meeting;
        const filterdMeetings = meetings.filter(
            (meeting) => meeting.hasMinutes === false
        )
        setOptions(filterdMeetings);
    }
    useEffect(() => {
        allTheMeetings()
    },
        []
    )
    return (
        <>
            <SelectEmployee
                selectedEmployees={selectedEmployees}
                confirm={(data) => {
                    const staff = data[0];
                    const responsibleName = resources?.find(
                        (item) => item.id === staff.id
                    );

                    if (type === "responsible") {
                        setInfo({
                            ...info,
                            responsibleTo: responsibleName.id,
                            responsibleName: responsibleName.names,
                        });
                    } else {
                        setInfo({
                            ...info,
                            reportTo: responsibleName.id,
                            reportName: responsibleName.names,
                        });
                    }
                    setSelectedEmployees([]);
                }}
                getEmployees={GetEmployees}
                settings={settings}
                open={selectEmployee}
                onClose={() => setSelectEmployee(false)}
                resources={resources}
            />

            <Modal maxWidth={"sm"} title="Add New Action" select={select} setSelect={setSelect}>
                <form
                    onSubmit={async (e) => {
                        e.preventDefault();
                        setLoading(true); // Start loading

                        try {
                            const response = await axios.post("/api/task/create", info);

                            if (response.status === 200) {
                                // Add the new task to the list of tasks  
                                const newAction = axios.get("api/task/list/notRelated");
                                setListOfAction((prevActions) => [...prevActions, newAction]);
 
                                if (!needDirectSubmit) {
                                    setListOfAction([...listOfAction, info]);
                                }
                                // Close the modal
                                setSelect(false);
                            } 
                        } catch (error) {
                        } finally {
                            setLoading(false); 
                        }
                    }}
                >             

                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div className="mb-3 grid grid-cols-1 gap-2">
                            <div className="col-md-6 mb-3">
                                <label className="col-form-label fw-bold text-capitalize">
                                    Name
                                    <span className="text-red-500 fs-6">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={info?.name}
                                    required={true}
                                    onChange={(event) => setInfo({ ...info, name: event.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                        <label className="col-form-label fw-bold text-capitalize">
                            Originate From
                            <span className="text-red fs-6">*</span>
                        </label>
                        <select
                            value={info?.meetingId || ""} // Default to the selectedMeeting if provided
                            className="form-select text-capitalize px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            required={true}
                            onChange={(e) =>
                                setInfo({ ...info, meetingId: e.target.value })
                            }
                        >
                            {options.map((meeting) => (
                                <option 
                                    key={meeting.id} 
                                    value={meeting.id} 
                                    disabled={meeting.id !== info?.meetingId} // Disable all options except the preselected one
                                >
                                    {meeting.name}
                                </option>
                            ))}
                        </select>

                        </div>
                        <div className="mb-3 grid grid-cols-1 gap-2">
                            <div className="col-md-3 mb-3">
                                <label className="col-form-label fw-bold text-capitalize">
                                    Start Date
                                    <span className="text-red-500 fs-6">*</span>
                                </label>
                                <div>
                                    <input
                                        type="date"
                                        name="start"
                                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={info?.startDate}
                                        required={true}
                                        onChange={(event) => {
                                            setInfo({ ...info, startDate: event.target.value });
                                        }} />
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 grid grid-cols-1 gap-2">
                            <div className="col-md-6 mb-3">
                                <label className="col-form-label fw-bold text-capitalize">
                                    End Date
                                    <span className="text-red-500 fs-6">*</span>
                                </label>
                                <div>

                                    <input
                                        type="date"
                                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={info?.endDate}
                                        required={true}
                                        min={info?.startDate}
                                        onChange={(event) => {
                                            setInfo({ ...info, endDate: event.target.value });
                                        }} />
                                </div>
                            </div>
                        
                        </div>
                    </div>


                    <div className="col-md-12 mb-3">
                        <label className="col-form-label fw-bold text-capitalize">
                            Description
                            <span className="text-red-500 fs-6">*</span>
                        </label>

                        <JoditEditorExample
                            htmlContent={info?.description}
                            onBlur={(str) => {
                                setInfo((prev) => ({ ...prev, description: str.target.value }));
                            }}
                        />
                    </div>
                </div>
                <CardActions className={"float-end"}>
                    <Button
                        color={"error"}
                        size="small"
                        variant="contained"
                        onClick={()=>setTimeout(()=>setSelect(false),100)}
                        
                        >
                        Close
                        
                    </Button>
                    <>
                        <Button
                        type="submit"
                        size="small"
                        variant="contained"
                        style={{ backgroundColor: mainBackground }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={20} /> : "Submit"}
                    </Button>
                    </>
                </CardActions>
            </form>

        </Modal>
    </>
)}

export default AddModal;

